import actions from '../actions/lodgingCancellationPolicyActions';

import createReducer from '../utils/createReducer';

// see graphql-lodging-policy type LodgingCancellationPolicy
export const initialState = {
    datesDoNotQualifyForCancellationText: '',
    badgeText: null,
    policy: '',
    policyWithDates: null,
    policyPeriods: [],
    policyPeriodsWithDates: []
};

const actionHandlers = {
    [actions.UPDATE_LODGING_CANCELLATION_POLICY](_, {payload = {}}) {
        const {lodgingCancellationPolicy} = payload;
        return {...initialState, ...lodgingCancellationPolicy};
    }
};

export default createReducer(actionHandlers, initialState);
